import React, { useState, useEffect } from "react";
import {Link, useHistory } from "react-router-dom";

//UI
import { Row, Col, Form, message, Spin } from "antd";
import { CPButton, CPInput } from "components/CP";
import logo from "assets/images/logo-login.png";
import PageContainer from "components/PageContainer/PageContainer";
//Context
import {types,useAdminContext} from 'context/AdminContext'
//API
import { userServices } from "services/userServices";

import { add, edit, title, description,close,status, action, remove, deleteMessage,addInformation, yes, no, requiredMessage,active,deactivate } from "lang/fa.json"


const { useForm } = Form;


const Index = ({  onSubmit, onCloseModal  }) => {
  const [loading, setLoading] = useState(false);
  const [form] = useForm();

  let history = useHistory();





  const onFinish = async (data) => {
    onSubmit(data);
  };



  const GetUserData = async () => {
    
    const result = await userServices.getUserForProfile();
    if (result.isSuccess) {
      form.setFieldsValue({
        ...result.data,
      });
    }
  };

  useEffect(() => {
    GetUserData()
  }, []);

  return (
    <div>

      <div className="footer-modal">
        <Row>
          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            layout="vertical"
          >
            <Row gutter={[24, 24]}>

              <Col xs={24} sm={12} md={12}>
                <CPInput
                  label={" نام"}
                  hasValidation
                  name={"firstName"}
                  type={"text"}
                  placeholder={" نام"}
                  rules={[
                    {
                      required: true,
                      message: requiredMessage,
                    },
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={12}>
                <CPInput
                  label={" نام خانوادگی"}
                  hasValidation
                  name={"lastName"}
                  type={"text"}
                  placeholder={" نام خانوادگی"}
                  rules={[
                    {
                      required: true,
                      message: requiredMessage,
                    },
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={12}>
                <CPInput
                  label={`نام کاربری  `}
                  hasValidation
                  name={"userName"}
                  type={"text"}
                  placeholder={`نام کاربری`}
                  rules={[
                    {
                      required: true,
                      message: requiredMessage,
                    },
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={12}>
                <CPInput
                  label={"  ایمیل"}
                  hasValidation
                  name={"email"}
                  type={"email"}
                  placeholder={"  ایمیل"}
                  rules={[
                    {
                      required: true,
                      message: requiredMessage,
                    },
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={12}>
                <CPInput
                  label={" شماره موبایل "}
                  hasValidation
                  name={"mobileNumber"}
                  type={"text"}
                  placeholder={" شماره موبایل "}
                  rules={[
                    {
                      required: true,
                      message: requiredMessage,
                    },
                  ]}
                />
              </Col>

              <Col xs={24} sm={12} md={24} className="login-button">
                <CPButton type="primary" htmlType="submit" loading={loading}>
                   ذخیره
                </CPButton>
                {" "}
                <CPButton onClick={onCloseModal}>{close}</CPButton>

              </Col>
           

            </Row>



          </Form>

        </Row>
      </div>
    </div>
  );
};

export default Index;
